import { useEffect } from 'react';
import { useGo } from '../../app/navigation';
import { lessonsOf } from '../../content/lessons';
import { isLessonDone, lessonDone, useProgress } from '../../core/store';
import { toast } from '../../core/toast';
import { Btn } from '../../ui/Button';
import { Icon } from '../../ui/icons';
import { Rich } from '../../ui/Rich';
import { modStyle } from '../../ui/style';
import { MODNAME } from '../module/info';
import { LessonBlocks } from './blocks';

export function LessonPage({ module, id }: { module: string; id: string }) {
  const go = useGo();
  useProgress();
  const lessons = lessonsOf(module);
  const idx = lessons.findIndex((l) => l.id === id);
  const les = lessons[idx];
  useEffect(() => {
    if (!les) go(module);
  }, [les, go, module]);
  if (!les) return null;
  const done = isLessonDone(module, les.id);
  const next = lessons[idx + 1];
  return (
    <article className="lesson" style={modStyle(module)}>
      <header className="lesson-head">
        <button type="button" className="link-back" onClick={() => go(module)}>
          <Icon name="left" />
          <span>{MODNAME[module]}</span>
        </button>
        <div className="eyebrow">
          Ders {idx + 1} / {lessons.length}
          {les.minutes ? ` · ${les.minutes} dk` : ''}
          {done ? ' · tamamlandı' : ''}
        </div>
        <h1 className="lesson-title">
          <Rich text={les.title} />
        </h1>
        {les.summary ? (
          <p className="lesson-sum">
            <Rich text={les.summary} />
          </p>
        ) : null}
      </header>
      <LessonBlocks blocks={les.blocks} />
      <footer className="lesson-foot">
        <Btn
          kind={done ? 'ghost' : 'primary'}
          icon="check"
          onClick={() => {
            if (lessonDone(module, les.id)) toast('+15 XP · Ders tamamlandı', { tone: 'good', icon: 'check' });
            go(next ? `${module}.ders.${next.id}` : module);
          }}
        >
          {done ? 'Tamamlandı' : 'Dersi tamamladım'}
        </Btn>
        {next ? (
          <button type="button" className="next-lesson" onClick={() => go(`${module}.ders.${next.id}`)}>
            <span className="nl-k">Sonraki ders</span>
            <span className="nl-t">
              <Rich text={next.title} />
            </span>
            <Icon name="right" />
          </button>
        ) : null}
      </footer>
    </article>
  );
}
